// Vault deck definitions. themedRate is the extra chance, above the one guaranteed themed
// card, that each remaining reward is also the deck's variant.
export const SECRET_DECKS = [
  {
    id: 'holoriphic-legends',
    name: 'Holo Legends Deck',
    variant: 'holo',
    rewardCount: 6,
    themedRate: 0.2,
    description: '"Aloha, Holoa!"',
  },
  {
    id: 'antique-archive',
    name: 'Antique Archive Deck',
    variant: 'antique',
    rewardCount: 6,
    themedRate: 0.2,
    description: '"Give me that old time religion!"',
  },
  {
    id: 'foil-tempest',
    name: 'Foil Tempest Deck',
    variant: 'foil',
    rewardCount: 6,
    themedRate: 0.3,
    description: '"Yeah they\'re cool, I guess."',
  },
//   {
//     id: 'ghost-echoes',
//     name: 'Ghost Echoes Deck',
//     variant: 'ghost',
//     rewardCount: 10,
//     cost: 12,
//     themedRate: 0.14,
//     description: '"You\'re seeing things."',
//   },
  {
    id: 'blueprint-foundry',
    name: 'Blueprint Foundry Deck',
    variant: 'blueprint',
    rewardCount: 6,
    themedRate: 0.2,
    description: '"Rubber-stamped and paid in full."',
  },
  {
    id: 'keepsake-album',
    name: 'Keepsake Album Deck',
    variant: 'crayon',
    rewardCount: 6,
    themedRate: 0.2,
    description: '"Poqueta\'s first drawing"',
  },
  {
    id: 'cosmic-garden',
    name: 'Cosmic Garden Deck',
    variant: 'cosmic',
    rewardCount: 6,
    themedRate: 0.15,
    description: '"Blast-off!"',
  },
  {
    id: 'sakura-parade',
    name: 'Sakura Parade Deck',
    variant: 'cutesy',
    rewardCount: 6,
    themedRate: 0.1,
    description: '"こんにちは!"',
  },
];
